<template>
  <div>
    <v-app-bar
    height="100px"
    color="white"
    v-if="$vuetify.breakpoint.xs"
    src="../assets/header.jpg">
      <router-link to="/">
        <img src="../assets/logo.png"
        width="140px"
        gradient="to top right, rgba(255,255,255,.1), rgba(255,255,255,.1)">
      </router-link>
      <v-spacer />
      <template>
        <v-app-bar-nav-icon
        @click="drawer = !drawer"
        class="mr-3"
        x-large>
        </v-app-bar-nav-icon>
      </template>
    </v-app-bar>
    <v-app-bar
    height="100px"
    color="white"
    v-else-if="$vuetify.breakpoint.sm"
    src="../assets/header.jpg">
    <router-link to="/">
      <img src="../assets/logo.png"
      width="148px">
    </router-link>
    <!--ナビゲーション-->
    <template v-slot:extension>
        <v-tabs
        slider-color="blue-grey darken-3"
        background-color="white"
        class="black--text"
        height="55px"
        fixed-tabs
        icons-and-text
        show-arrows
        >
          <v-tab
          v-for="item in pages"
          :key="item.page"
          :to="item.link"
          >
            {{ item.page }}
            <v-icon>{{ item.icon }}</v-icon>
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
    <v-app-bar
    color="white"
    height="100px"
    v-else-if="$vuetify.breakpoint.md"
    src="../assets/header.jpg">
    <router-link to="/">
    <img src="../assets/logo.png"
    width="200px">
    </router-link>
    <!--ナビゲーション-->
    <template v-slot:extension>
        <v-tabs
        slider-color="blue-grey darken-3"
        background-color="white"
        class="black--text"
        height="55px"
        fixed-tabs
        icons-and-text
        show-arrows
        >
          <v-tab
          v-for="item in pages"
          :key="item.page"
          :to="item.link"
          >
            {{ item.page }}
            <v-icon>{{ item.icon }}</v-icon>
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
    <v-app-bar
    color="white"
    height="110px"
    v-else-if="$vuetify.breakpoint.lg"
    src="../assets/header.jpg">
    <router-link to="/">
    <img src="../assets/logo.png"
    width="250px"
    class="ml-4">
    </router-link>
    <!--ナビゲーション-->
      <template v-slot:extension>
        <v-tabs
        slider-color="blue-grey darken-3"
        background-color="white"
        class="black--text"
        height="55px"
        fixed-tabs
        icons-and-text
        show-arrows
        >
          <v-tab
          v-for="item in pages"
          :key="item.page"
          :to="item.link"
          >
            {{ item.page }}
            <v-icon>{{ item.icon }}</v-icon>
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
    <v-app-bar
    color="white"
    height="110px"
    v-else-if="$vuetify.breakpoint.xl"
    src="../assets/header.jpg">
    <router-link to="/">
    <img src="../assets/logo.png"
    width="255px"
    class="ml-4">
    </router-link>
    <!--ナビゲーション-->
      <template v-slot:extension>
        <v-tabs
        slider-color="blue-grey darken-3"
        background-color="white"
        class="black--text"
        fixed-tabs
        height="55px"
        icons-and-text
        show-arrows
        >
          <v-tab
          v-for="item in pages"
          :key="item.page"
          :to="item.link"
          >
            {{ item.page }}
            <v-icon>{{ item.icon }}</v-icon>
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
    <!--ハンバーガーメニューをタップすると右に表示されるナビゲーション-->
    <v-navigation-drawer
      absolute
      temporary
      right
      v-model="drawer"
      color="white"
      class="fomt-weight-medium"
      width="220px"
    >
      <v-list-item two-line>
        <v-icon>
          mdi-home-city
        </v-icon>
        <v-list-item-content class="ml-2">
          <router-link to="/" id="toHome">
          <v-list-item-title>有限会社 小西住建</v-list-item-title>
          </router-link>
        </v-list-item-content>
      </v-list-item>
      <v-divider dark></v-divider>
      <v-list dense>
        <v-list-item
          v-for="item in pages"
          :key="item.page"
          :to="item.link"
        >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
          <v-list-item-content class="py-1">
            <v-list-item-title>{{ item.page }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-3"></v-divider>
        <v-list-item>
          <br><br>
          〒770-0936<br>
          徳島県徳島市中央通3丁目１番地<br>
          電話番号  : 088-625-3586<br>
          FAX番号  : 088-625-1830
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<style>
.v-slide-group__wrapper {
  position: relative;
}
#toHome {
  text-decoration: none;
  color: black;
}
</style>

<script>
export default {
  data () {
    return {
      // ナビゲーションドロワー
      drawer: false,
      pages: [
        {
          page: 'Home',
          icon: 'mdi-home',
          link: '/'
        },
        {
          page: '物件情報',
          icon: 'mdi-city',
          link: '/Property'
        },
        {
          page: '会社概要',
          icon: 'mdi-home-city',
          link: '/Company'
        }
      ]
    }
  }
}
</script>
